import React from "react";

const FilterIcon = ({ selected, Icon, Swoosh }) => {
  return (
    <div className="filter-icon">
      {selected && (
        <div className={`swooshes ${selected ? "" : "hidden"}`}>
          <Swoosh />
        </div>
      )}
      <div className="icon">
        <Icon isSelected={selected} />
      </div>
    </div>
  );
};

export default FilterIcon;
